import { Box, Typography, Avatar, Alert } from '@mui/material'
import CelebrationIcon from '@mui/icons-material/Celebration'
import FavoriteIcon from '@mui/icons-material/Favorite'
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium'
import theme from '../../theme'

const PromotionBanner = ({ message, style = 'info', sx = {}, dense = false, size = 'md' }) => {
  if (!message) return null

  const effectiveSize = dense ? 'sm' : (size || 'md')
  const metrics = effectiveSize === 'lg'
    ? { px: 2.5, py: 2, avatar: 40, fontSize: '1.05rem' }
    : effectiveSize === 'sm'
      ? { px: 1.5, py: 1.2, avatar: 30, fontSize: '0.9rem' }
      : { px: 2, py: 1.6, avatar: 34, fontSize: '1rem' }

  const baseSx = {
    borderRadius: 3,
    overflow: 'hidden',
    ...sx,
  }

  const normalizedStyle = style || 'info'

  if (normalizedStyle === 'festive' || normalizedStyle === 'love' || normalizedStyle === 'premium') {
    const themeByStyle = {
      festive: {
        icon: <CelebrationIcon sx={{ color: 'white' }} />,
        bg: 'linear-gradient(135deg, #ff6a00 0%, #ee0979 60%, #7f00ff 100%)',
      },
      love: {
        icon: <FavoriteIcon sx={{ color: 'white' }} />,
        bg: 'linear-gradient(135deg, #ff4d6d 0%, #ff758f 55%, #c9184a 100%)',
      },
      premium: {
        icon: <WorkspacePremiumIcon sx={{ color: 'white' }} />,
        bg: 'linear-gradient(135deg, #0f172a 0%, #111827 55%, #b45309 100%)',
      },
    }

    const conf = themeByStyle[normalizedStyle]

    return (
      <Box
        sx={{
          ...baseSx,
          border: '1px solid rgba(255,255,255,0.18)',
          background: conf.bg,
          position: 'relative',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            background:
              'radial-gradient(circle at 20% 10%, rgba(255,255,255,0.18), transparent 40%), radial-gradient(circle at 80% 30%, rgba(255,255,255,0.12), transparent 45%)',
            pointerEvents: 'none',
          }}
        />
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            px: metrics.px,
            py: metrics.py,
            position: 'relative',
          }}
        >
          <Avatar
            sx={{
              width: metrics.avatar,
              height: metrics.avatar,
              bgcolor: 'rgba(255,255,255,0.18)',
              border: '1px solid rgba(255,255,255,0.25)',
            }}
          >
            {conf.icon}
          </Avatar>
          <Typography
            sx={{
              fontWeight: 900,
              color: 'white',
              letterSpacing: 0.2,
              flex: 1,
              fontSize: metrics.fontSize,
              lineHeight: 1.25,
            }}
          >
            {message}
          </Typography>
        </Box>
      </Box>
    )
  }

  const severity = normalizedStyle === 'success' || normalizedStyle === 'warning' || normalizedStyle === 'info' ? normalizedStyle : 'info'

  return (
    <Alert
      severity={severity}
      sx={{
        ...baseSx,
        py: metrics.py - 0.2,
        '& .MuiAlert-message': {
          width: '100%',
        },
      }}
    >
      <Typography sx={{ fontWeight: 700, fontSize: metrics.fontSize }}>{message}</Typography>
    </Alert>
  )
}

export default PromotionBanner
